import { GLServiceBase, ServiceRoute } from "commonui";
import { IAssetListService } from "./interface";
import {
	AssetListParamsModel,
	AssetListResponseModel,
	AsssetResponseModel,
	SaveAssetRequestModel,
	SaveAssetTagsRequestModel
} from "./model";

class AssetListServiceClass extends GLServiceBase<any, any> implements IAssetListService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/assets" };

	constructor() {
		super();
		this.getAssetList = this.getAssetList.bind(this);
	}

	getAssetList(params: AssetListParamsModel): Promise<AssetListResponseModel[]> {
		return this.get(params);
	}

	saveAsset(params: SaveAssetRequestModel): Promise<void> {
		return this.create(params);
	}

	editAsset(params: SaveAssetRequestModel, assetId: number): Promise<void> {
		return this.update("{assetId}", params, { assetId });
	}

	saveAssetTags(params: SaveAssetTagsRequestModel, assetId: string): Promise<void> {
		return this.update("{assetId}/tags", params.tagIds, { assetId });
	}

	getAsset(assetId: number): Promise<AsssetResponseModel> {
		return this.get("{assetId}", null, { assetId });
	}

	deleteAsset(assetId: number): Promise<void> {
		return this.delete("{assetId}", { assetId });
	}
}

export const AssetListService = new AssetListServiceClass();
